import { ProviderPortal } from './ProviderPortal';

/** Vendor composition; the product feature owns all workflows and session checks. */
export function VendorApp() {
  return <ProviderPortal />;
}
